import classNames from 'classnames';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AnswerType6 from './components/AnswerType6/AnswerType6';
import AnswerType7 from './components/AnswerType7/AnswerType7';
import './style.scss';


function Answers({ answers, questionType }) {
  console.log("🚀 ~ file: Answers.jsx ~ line 8 ~ Answers ~ answers", answers)
  return (
    <div className='AnswersQuestion'>

        {questionType == 'type1' && answers}
        {questionType == 'type7' && <AnswerType7 answers={answers} />}
        {questionType == 'type6' && <AnswerType6 answers={answers || {}} />}
        {questionType == 'type5' && answers.variants.join(', ')}
        {(questionType == 'type2' || questionType == 'type3') && (answers || []).map(_i => 
          <div key={_i._id} className={classNames('item_answer_question', {isTrue: _i.isTrue})}>
            {_i.url && <img src={_i.url} />}
            {!_i.url && _i.text}
          </div>
        )}
        {(questionType == 'type4') && (answers || []).map(item => 
          <div key={item._id} className='ItemsCategoryAnswers'>
            <div className='title'>{item.title}</div>
            <div className='items'>
              {item.variants.map(_i =>
                <div key={_i._id} className={classNames('item_answer_question', {isTrue: _i.isTrue})}>
                  {_i.url && <img src={_i.url} />}
                  {!_i.url && _i.text}
                </div>
               )}
            </div>
          </div>
        )}
    </div>
  )
}

export default Answers


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/Answers.jsx